import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { alpha, ComponentsOverrides, ComponentsProps, ComponentsVariants, CssVarsTheme } from '@mui/material/styles';
import { createElement } from 'react';

export const MuiAutocomplete: {
  defaultProps?: ComponentsProps['MuiAutocomplete'];
  styleOverrides?: ComponentsOverrides<CssVarsTheme>['MuiAutocomplete'];
  variants?: ComponentsVariants['MuiAutocomplete'];
} = {
  styleOverrides: {
    popupIndicator: {
      width: 24,
      height: 24
    },
    clearIndicator: {
      width: 24,
      height: 24
    },
    paper: ({ theme }) => ({
      marginTop: theme.spacing(1),
      boxShadow: theme.vars.customShadow.secondary.center,
      borderRadius: 8,
      backdropFilter: 'blur(20px)',
      backgroundColor: alpha('#fff', 0.9),
      padding: '4px'
    }),
    option: {
      fontSize: '0.875rem'
    },
    listbox: ({ theme }) => ({
      padding: 0,
      '& .MuiAutocomplete-option': {
        lineHeight: 1.5714285714285714,
        fontSize: '0.875rem',
        borderRadius: 6,
        padding: '0.5rem',
        '&:not(:last-of-type)': {
          marginBottom: 4
        },
        '&.Mui-selected': {
          backgroundColor: alpha(theme.palette.primary.light, 0.16),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.light, 0.08)
          }
        },
        '& .MuiCheckbox-root': {
          padding: '4px',
          marginLeft: '-4px',
          marginRight: '4px'
        },
        '&.MuiAutocomplete-option[aria-selected="true"]': {
          backgroundColor: alpha(theme.palette.primary.light, 0.16),
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.light, 0.08)
          }
        },
        '&+.MuiDivider-root': {
          margin: '4px 0px'
        }
      }
    })
  },
  defaultProps: {
    popupIcon: createElement(ExpandMoreRounded, { className: '!w-6 !h-6' }, undefined)
  }
};
